const PAD = 12;
const GAP = 6;

/** Where the popup goes, in pixels from the top-left of the window. */
export interface PopupPlacement {
  top: number;
  left: number;
  maxHeight: number;
}

interface TriggerBox {
  top: number;
  bottom: number;
  left: number;
}

interface PopupSize {
  width: number;
  height: number;
}

interface Viewport {
  width: number;
  height: number;
}

/**
 * Where to put the popup so it stays on screen: below the trigger when it fits (or when below has more room),
 * otherwise above, and never past the edges. When neither side is tall enough it is capped and scrolls.
 */
export const placePopup = (trigger: TriggerBox, popup: PopupSize, viewport: Viewport): PopupPlacement => {
  const spaceBelow = viewport.height - trigger.bottom - GAP - PAD;
  const spaceAbove = trigger.top - GAP - PAD;

  let left = trigger.left;
  if (left + popup.width > viewport.width - PAD) left = viewport.width - popup.width - PAD;
  if (left < PAD) left = PAD;

  let top: number;
  let maxHeight: number;
  if (popup.height <= spaceBelow || spaceBelow >= spaceAbove) {
    top = trigger.bottom + GAP;
    maxHeight = spaceBelow;
  } else if (popup.height <= spaceAbove) {
    top = trigger.top - GAP - popup.height;
    maxHeight = spaceAbove;
  } else {
    maxHeight = spaceAbove;
    top = trigger.top - GAP - maxHeight;
  }

  return { top: Math.max(top, PAD), left, maxHeight };
};
